import React from "react";
import { Button as MuiButton } from "@material-ui/core";
import { Link } from "react-router-dom";
import styles from "./Button.module.css";

type Color = "black" | "white" | "grey" | "orange" | "purple" | "none";

const Button: any = React.forwardRef(
  (
    {
      children,
      color,
      onClick,
      disabled,
      href,
      self,
      style,
      className,
    }: {
      children: React.ReactNode;
      color?: Color;
      onClick?: any;
      disabled?: boolean;
      href?: string;
      self?: boolean;
      style?: React.CSSProperties;
      className?: string;
    },
    ref: React.Ref<HTMLAnchorElement | HTMLDivElement>
  ) => {
    if (!color) color = "white";

    const ButtonContent = (
      <MuiButton
        ref={ref as any}
        disabled={disabled}
        style={{ ...(disabled && { opacity: 0.5 }), ...style }}
        className={`${styles.button} ${className || ""} `}
        id={styles[`${color}Button`]}
        onClick={!onClick && disabled ? () => {} : onClick}
      >
        {children}
      </MuiButton>
    );

    if (self)
      return (
        <Link style={{ textDecoration: "none" }} to={href || ""}>
          {ButtonContent}
        </Link>
      );
    else if (href) {
      return (
        <a
          href={href}
          target={self ? "_self" : "_blank"}
          rel="noopener noreferrer"
        >
          {ButtonContent}
        </a>
      );
    } else return <div>{ButtonContent}</div>;
  }
);

export default Button;
